<ef-help-desk
[processesCategories]='processesCategories$ | async'
></ef-help-desk>
